import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const useExpirationFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    expirationWithin: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ expirationWithin }) => {
    setFilters(
      { expirationWithin: expirationWithin.value || 'any' },
      {
        removeFilters: expirationWithin.value === 'any' ? ['expirationWithin'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
  };
};

useExpirationFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
